module.exports = __webpack_public_path__ + "h5/static/img/left_quan.eb21e291.png";